// TODO: Reconfigure Paths
const routes = [
  {
    path: ["/", "/LoginPage"],
    exact: true,
    component: "LoginPage",
  },

  {
    path: ["/ForgotUsername"],
    component: "ForgotUserName",
  },
  {
    path: ["/Registration"],
    component: "Registration",
  },
  // {
  //   path: ["/trustedbrowser"],
  //   component: "TrustedBrowserPage",
  // },
  // {
  //   path: ["/browserRegistrationNafath"],
  //   component: "BrowserRegistrationWithNafath",
  // },
  // {
  //   path: ["/authentication"],
  //   component: "Authentication",
  // },
  {
    path: ["/ChangeUsername"],
    component: "ChangeUsername",
  },
  // {
  //   path: ["/ForgotPassword"],
  //   component: "ForgotPswd",
  // },

  {
    path: ["/ChangePassword"],
    component: "ChangePasswordPage",
  },
  // {
  //   path: ["/SwitchSecureKey"],
  //   component: "SwitchSecureKey",
  // },
  // {
  //   path: ["/ActivateSecureKey"],
  //   component: "ActivateSecureKey",
  // }
];

export default routes;
